import httpClient from './httpClient'
import _ from 'lodash'

const END_POINT = '/api/remesas'

const getAll = async (idcurso) => {
    return await httpClient.get(END_POINT, {
      "params": { curso: idcurso, "order[fecha]": "desc", "pagination": "false" }
    })
}

const newRemesa = async (item) => {
  
  if ( _.isNil(item.curso) ) {
    throw new Error('No es posible añadir la remesa, el curso es nulo.')
  }

  return await httpClient.post(END_POINT, item)

}

const descargarFichero = async (idRemesa) => {

  if ( _.isNil(idRemesa) ) {
    throw new Error('No es posible descargar el fichero, el id de remesa es nulo.')
  }

  return await httpClient.get(`${END_POINT}/descargar-fichero`, {
    "params": { id: idRemesa }
  })

}

export {

    getAll,
    newRemesa,
    descargarFichero

}